<div class=" order_sum_wrapper ">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border">Driver's Information
            <span *ngIf="isShowPassword">(Mode: Add)</span>
            <span *ngIf="!isShowPassword">(Mode: Edit)</span>
        </legend>
        <div class="col-md-12">



            <form name="form" (ngSubmit)="saveDriver()" #driver="ngForm" [mustMatch]="['password', 'Retypepassword']">
                <div class="container_pad">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin_7">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">First Name:</label>
                                        <input type="text" id="fname" name="fname" placeholder="First Name" [(ngModel)]="driverVM.FirstName" #fname="ngModel" class="form-control" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': fname.invalid && (fname.dirty || fname.Select)}" autofocus
                                            required />

                                        <div *ngIf="fname.invalid && (fname.dirty || fname.Select)" class="invalid-feedback">
                                            <div *ngIf="fname.errors?.required">First Name is required</div>
                                            <div *ngIf="fname.errors?.minlength || fname.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">Last Name:</label>
                                        <input type="text" id="lastName" name="lastName" placeholder="Last Name" [(ngModel)]="driverVM.LastName" #lastName="ngModel" class="form-control" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': lastName.invalid && (lastName.dirty || lastName.Select)}"
                                            required />

                                        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.Select)" class="invalid-feedback">
                                            <div *ngIf="lastName.errors?.required">Last Name is required</div>
                                            <div *ngIf="lastName.errors?.minlength || lastName.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">Phone:</label>
                                        <input type="text" id="phone" name="phone" placeholder="Phone" [(ngModel)]="driverVM.Phone" #phone="ngModel" class="form-control" [ngClass]="{ 'is-invalid': phone.invalid && (phone.dirty || phone.Select)}" mask="(000) 000-0000" required />
                                        <div *ngIf="phone.invalid && (phone.dirty || phone.Select)" class="invalid-feedback">
                                            <div *ngIf="phone.errors?.required">Phone no is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">Alternate Phone::</label>
                                        <input type="text" id="phoneNo" name="phoneNo" placeholder="Alternate Phone" [(ngModel)]="driverVM.AlternatePhone" #phoneNo="ngModel" class="form-control" [ngClass]="{ 'is-invalid': phoneNo.invalid && (phoneNo.dirty || phoneNo.Select)}" mask="(000) 000-0000"
                                        />
                                        <div *ngIf="phoneNo.invalid && (phoneNo.dirty || phoneNo.Select)" class="invalid-feedback">
                                            <div *ngIf="phoneNo.errors?.required">Alternate Phone is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">Email:</label>
                                        <input type="text" id="email" name="email" placeholder="Email" pattern="[a-zA-Z0-9]\.?([a-zA-Z0-9._%+-])+@[a-z0-9.-]+\.[a-z]{2,4}$" [(ngModel)]="driverVM.Email" #email="ngModel" class="form-control" [ngClass]="{ 'is-invalid': email.invalid && (email.dirty || email.Select) }"
                                            required email />

                                        <div *ngIf="email.invalid && (email.dirty || email.Select)" class="invalid-feedback">
                                            <div *ngIf="email.errors?.required">Email is required</div>
                                            <div *ngIf="email.errors?.pattern">Email must be a valid email address</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">Password:</label>
                                        <input type="password" id="password" name="password" placeholder="Password  min 6 characters" [(ngModel)]="driverVM.Password" #password="ngModel" minlength="6" class="form-control" pattern='^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{3,}$' [ngClass]="{ 'is-invalid': password.invalid && (password.dirty || password.Select) }"
                                            required />
                                        <div *ngIf="password.invalid && (password.dirty || password.Select)" class="invalid-feedback">
                                            <div *ngIf="password.errors?.required">Password is required</div>
                                            <div *ngIf="password.errors?.pattern">1 numeric, upper & lowercase req.</div>
                                            <div *ngIf="password.errors?.minlength pass_validation_fld">Password should contain at least -<br> 6 chahracters.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="fName" class="control-label">Retype Password:</label>
                                        <input type="password" id="Retypepassword" name="Retypepassword" placeholder="Retype Password" [(ngModel)]="driverVM.RetypePassword" #Retypepassword="ngModel" class="form-control" [ngClass]="{ 'is-invalid': Retypepassword.invalid && (Retypepassword.dirty || Retypepassword.Select) }"
                                            required />
                                        <div *ngIf="Retypepassword.invalid && (Retypepassword.dirty || Retypepassword.Select)" class="invalid-feedback">
                                            <div *ngIf="Retypepassword.errors.required">Retype Password is required.</div>
                                            <div *ngIf="Retypepassword.errors.mustMatch">Password do not match!</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="address">Address Line 1:</label>
                                        <input type="text" id="Addressline1" name="Addressline1" placeholder="Address Line 1" [(ngModel)]="driverVM.AddressLine1" #add1="ngModel" class="form-control" minlength="3" maxlength="250" [ngClass]="{ 'is-invalid': add1.invalid && (add1.dirty || add1.Select) }"
                                            required />
                                        <div *ngIf="add1.invalid && (add1.dirty || add1.Select)" class="invalid-feedback">
                                            <div *ngIf="add1.errors.required">Address is required.</div>
                                            <div *ngIf="add1.errors.minlength || add1.errors?.maxlength">Address should be between 3 to 250 characters.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="address">Address Line 2:</label>
                                        <input type="text" id="Addressline2" name="Addressline2" placeholder="Address Line 2" [(ngModel)]="driverVM.AddressLine2" #add2="ngModel" class="form-control" minlength="3" maxlength="250" [ngClass]="{ 'is-invalid': add2.invalid && (add2.dirty || add2.Select) }"
                                        />
                                        <div *ngIf="add2.invalid && (add2.dirty || add2.Select)" class="invalid-feedback">
                                            <div *ngIf="add2.errors.minlength || add2.errors?.maxlength">Address should be between 3 to 250 characters.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="zipcode">Zip Code:</label>
                                        <input type="text" id="zipcode" name="zipcode" autocomplete="off" placeholder="Zip Code" [(ngModel)]="driverVM.Zipcode" #zipCode="ngModel" class="form-control" minlength="0" maxlength="5" appOnlynumber [ngClass]="{ 'is-invalid': zipCode.invalid && (zipCode.dirty || zipCode.Select) }"
                                            required />
                                        <div *ngIf="zipCode.invalid && (zipCode.dirty || zipCode.Select)" class="invalid-feedback">
                                            <div *ngIf="zipCode.errors.required">Zip code is required.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-1 col-lg-1 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="city">City:</label>
                                        <input type="text" id="city" name="city" placeholder="City" [(ngModel)]="driverVM.City" #city="ngModel" class="form-control" [ngClass]="{ 'is-invalid': city.invalid && (city.dirty || city.Select) }" minlength="2" maxlength="25" required />
                                        <div *ngIf="city.invalid && (city.dirty || city.Select)" class="invalid-feedback">
                                            <div *ngIf="city.errors.required">City is required.</div>
                                            <div *ngIf="city.errors.minlength || city.errors?.maxlength">Minimum 2 characters are required.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-1 col-lg-1 employee_sum_col pl-0 ">
                                    <div class="form-group has-feedback">
                                        <label for="state">State:</label>
                                        <input type="text" id="state" name="state" placeholder="State" [(ngModel)]="driverVM.State" #state="ngModel" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': state.invalid && (state.dirty || state.Select) }" class="form-control" required />
                                        <div *ngIf="state.invalid && (state.dirty || state.Select)" class="invalid-feedback">
                                            <div *ngIf="state.errors.required">State is required.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-12 col-md-2 col-lg-2 employee_sum_col pl-0 ">

                                    <div class="form-group orders_sum_top orders_sum_topW ">
                                        <div class="pull-right">
                                            <button type="submit" [disabled]="!driver.valid" class="btn btn-primary mr-2">Save</button>
                                            <button type="reset" id="resetDriverform" class="btn btn-default" (click)="cancelForm()">Cancel</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>





            <!-- <form name="form" (ngSubmit)="saveDriver()" #driver="ngForm" [mustMatch]="['password', 'Retypepassword']">
                <div class="row label-space first_field">
                    <div class=" order_sum_col order_sum_col_ field ">
                        <div class="form-group">
                            <label for="fname">First Name</label>
                            <input type="text" id="fname" name="fname" placeholder="First Name" [(ngModel)]="driverVM.FirstName" #fname="ngModel" class="form-control" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': fname.invalid && (fname.dirty || fname.Select)}" autofocus
                                required />

                            <div *ngIf="fname.invalid && (fname.dirty || fname.Select)" class="invalid-feedback">
                                <div *ngIf="fname.errors?.required">First Name is required</div>
                                <div *ngIf="fname.errors?.minlength || fname.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>
                    </div>
                    <div class=" order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="lastName">Last Name:</label>
                            <input type="text" id="lastName" name="lastName" placeholder="Last Name" [(ngModel)]="driverVM.LastName" #lastName="ngModel" class="form-control" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': lastName.invalid && (lastName.dirty || lastName.Select)}"
                                required />

                            <div *ngIf="lastName.invalid && (lastName.dirty || lastName.Select)" class="invalid-feedback">
                                <div *ngIf="lastName.errors?.required">Last Name is required</div>
                                <div *ngIf="lastName.errors?.minlength || lastName.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>
                    </div>
                    <div class=" order_sum_col order_sum_col_">

                        <div class="form-group">
                            <label for="phone">Phone:</label>
                            <input type="text" id="phone" name="phone" placeholder="Phone" [(ngModel)]="driverVM.Phone" #phone="ngModel" class="form-control" [ngClass]="{ 'is-invalid': phone.invalid && (phone.dirty || phone.Select)}" mask="(000) 000-0000" required />
                            <div *ngIf="phone.invalid && (phone.dirty || phone.Select)" class="invalid-feedback">
                                <div *ngIf="phone.errors?.required">Phone no is required</div>
                            </div>
                        </div>
                    </div>
                    <div class=" order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="phoneNo">Alternate Phone:</label>
                            <input type="text" id="phoneNo" name="phoneNo" placeholder="Alternate Phone" [(ngModel)]="driverVM.AlternatePhone" #phoneNo="ngModel" class="form-control" [ngClass]="{ 'is-invalid': phoneNo.invalid && (phoneNo.dirty || phoneNo.Select)}" mask="(000) 000-0000"
                            />
                            <div *ngIf="phoneNo.invalid && (phoneNo.dirty || phoneNo.Select)" class="invalid-feedback">
                                <div *ngIf="phoneNo.errors?.required">Alternate Phone is required</div>
                            </div>
                        </div>
                    </div>
                    <div class=" order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="email">Email:</label>
                            <input type="text" id="email" name="email" placeholder="Email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [(ngModel)]="driverVM.Email" #email="ngModel" class="form-control" [ngClass]="{ 'is-invalid': email.invalid && (email.dirty || email.Select) }"
                                required email />

                            <div *ngIf="email.invalid && (email.dirty || email.Select)" class="invalid-feedback">
                                <div *ngIf="email.errors?.required">Email is required</div>
                                <div *ngIf="email.errors?.pattern">Email must be a valid email address</div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isShowPassword" class=" order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="password">Password:</label>
                            <input type="password" id="password" name="password" placeholder="Password  min 6 characters" [(ngModel)]="driverVM.Password" #password="ngModel" minlength="6" class="form-control" pattern='^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{3,}$' [ngClass]="{ 'is-invalid': password.invalid && (password.dirty || password.Select) }"
                                required />
                            <div *ngIf="password.invalid && (password.dirty || password.Select)" class="invalid-feedback">
                                <div *ngIf="password.errors?.required">Password is required</div>
                                <div *ngIf="password.errors?.pattern">1 numeric, upper & lowercase req.</div>
                                <div *ngIf="password.errors?.minlength pass_validation_fld">Password should contain at least -<br> 6 chahracters.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isShowPassword" class=" order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="password">Retype Password:</label>
                            <input type="password" id="Retypepassword" name="Retypepassword" placeholder="Retype Password" [(ngModel)]="driverVM.RetypePassword" #Retypepassword="ngModel" class="form-control" [ngClass]="{ 'is-invalid': Retypepassword.invalid && (Retypepassword.dirty || Retypepassword.Select) }"
                                required />
                            <div *ngIf="Retypepassword.invalid && (Retypepassword.dirty || Retypepassword.Select)" class="invalid-feedback">
                                <div *ngIf="Retypepassword.errors.required">Retype Password is required.</div>
                                <div *ngIf="Retypepassword.errors.mustMatch">Password do not match!</div>
                            </div>
                        </div>
                    </div>


                    <div class="order_sum_col order_sum_col_ ">
                        <div class="form-group">
                            <label for="address">Address Line 1:</label>
                            <input type="text" id="Addressline1" name="Addressline1" placeholder="Address Line 1" [(ngModel)]="driverVM.AddressLine1" #add1="ngModel" class="form-control" minlength="3" maxlength="250" [ngClass]="{ 'is-invalid': add1.invalid && (add1.dirty || add1.Select) }"
                                required />
                            <div *ngIf="add1.invalid && (add1.dirty || add1.Select)" class="invalid-feedback">
                                <div *ngIf="add1.errors.required">Address is required.</div>
                                <div *ngIf="add1.errors.minlength || add1.errors?.maxlength">Address should be between 3 to 250 characters.</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_sum_col order_sum_col_">

                        <div class="form-group">
                            <label for="address">Address Line 2:</label>
                            <input type="text" id="Addressline2" name="Addressline2" placeholder="Address Line 2" [(ngModel)]="driverVM.AddressLine2" #add2="ngModel" class="form-control" minlength="3" maxlength="250" [ngClass]="{ 'is-invalid': add2.invalid && (add2.dirty || add2.Select) }"
                            />
                            <div *ngIf="add2.invalid && (add2.dirty || add2.Select)" class="invalid-feedback">
                                <div *ngIf="add2.errors.minlength || add2.errors?.maxlength">Address should be between 3 to 250 characters.</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="zipcode">Zip Code:</label>
                            <input type="text" id="zipcode" name="zipcode" autocomplete="off" placeholder="Zip Code" [(ngModel)]="driverVM.Zipcode" #zipCode="ngModel" class="form-control" minlength="0" maxlength="5" appOnlynumber [ngClass]="{ 'is-invalid': zipCode.invalid && (zipCode.dirty || zipCode.Select) }"
                                required />
                            <div *ngIf="zipCode.invalid && (zipCode.dirty || zipCode.Select)" class="invalid-feedback">
                                <div *ngIf="zipCode.errors.required">Zip code is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="city">City:</label>
                            <input type="text" id="city" name="city" placeholder="City" [(ngModel)]="driverVM.City" #city="ngModel" class="form-control" [ngClass]="{ 'is-invalid': city.invalid && (city.dirty || city.Select) }" minlength="2" maxlength="25" required />
                            <div *ngIf="city.invalid && (city.dirty || city.Select)" class="invalid-feedback">
                                <div *ngIf="city.errors.required">City is required.</div>
                                <div *ngIf="city.errors.minlength || city.errors?.maxlength">Minimum 2 characters are required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="order_sum_col order_sum_col_">
                        <div class="form-group">
                            <label for="state">State:</label>
                            <input type="text" id="state" name="state" placeholder="State" [(ngModel)]="driverVM.State" #state="ngModel" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': state.invalid && (state.dirty || state.Select) }" class="form-control" required />
                            <div *ngIf="state.invalid && (state.dirty || state.Select)" class="invalid-feedback">
                                <div *ngIf="state.errors.required">State is required.</div>
                            </div>
                        </div>
                    </div>

                    <div class="ml-10 order_sum_col order_sum_col_ pull-right driver_src_btn">
                        <div class="form-group orders_sum_top tag_report">
                            <div class="pull-right">
                                <button type="submit" [disabled]="!driver.valid" class="btn btn-primary">Save</button>
                                <button type="reset" id="resetDriverform" class="btn btn-default" (click)="cancelForm()">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form> -->

        </div>

    </fieldset>

    <fieldset class="scheduler-border clearfix marign_10">
        <legend class="scheduler-border">Driver's List</legend>
        <div class="panel_table">
            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>
                                <th>Full Name</th>
                                <th>Phone# </th>
                                <th>Alternate Phone# </th>
                                <th>Email </th>
                                <th>Address</th>
                                <th>Zip Code</th>

                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="drivers?.Drivers">
                            <tr *ngFor="let mod of drivers.Drivers">

                                <td>{{mod.FullName}}</td>
                                <td>{{mod.Phone}}</td>
                                <td>{{mod.AlternatePhone}}</td>
                                <td>{{mod.Email}}</td>
                                <td>{{mod.AddressLine1}}</td>
                                <td>{{mod.Zipcode}}</td>
                                <td>
                                    <a class="btn btn-small btn-link" (click)="updateDriver(mod)"> <i class="fa fa-pencil fa-lg" aria-hidden="true"></i> </a>
                                    <a class="btn btn-small btn-link" (click)="changePasswordPopup(mod.ID)"><i
                                            class="fa fa-edit fa-lg pad_left" aria-hidden="true"></i></a>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="drivers?.PaginatedResult?.TotalRecords > 10" style="float: right;">
                        <ngb-pagination [(page)]="pageNo" [maxSize]="10" [collectionSize]="drivers?.PaginatedResult?.TotalRecords" [ellipses]="true" [boundaryLinks]="true" (pageChange)="getDriver($event)">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <br>
</div>